import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { useApi } from "../../../../../hooks/useApi";
import { authType } from "../../../../../pages/Login";
import LineBtn from "../../../../Button/LineBtn";
import { exMemberListState } from "../PartyDetailMemberHistory";
import { IPartyDetailMemberInfo } from "../PartyDetailMemberInfo";
import PartyExitModal, {
  IPartyExitPartyData,
} from "../PartyExitModal/PartyExitModal";
import PartyExitRevertModal from "../PartyExitRevertModal/PartyExitRevertModal";

interface PartyExitBtnProps {
  fetchingEvent: () => void;
  d: IPartyDetailMemberInfo;
  data?: {
    members?: number;
    sset_value?: number;
    startdate?: string;
  };
  subsId: number;
  checkEvent?: () => void;
}

export default function PartyExitBtn({
  fetchingEvent,
  d,
  data,
  subsId,
  checkEvent,
}: PartyExitBtnProps) {
  console.log(data);

  const auth = useRecoilValue(authType);
  const { partyId } = useParams();

  const [partyExitModal, setPartyExitModal] = useState(false);
  const [partyData, setPartyData] = useState<IPartyExitPartyData>({
    uid: "",
    name: "",
    nickname: "",
    partyId: partyId!,
    subsId: subsId ?? 0,
    grade: 10,
    membs: 0,
  });

  useEffect(() => {
    setPartyData({
      uid: "",
      name: "",
      nickname: "",
      partyId: partyId!,
      subsId: subsId ?? 0,
      grade: 10,
      membs: 0,
    });
  }, [partyId, subsId]);

  const [partyExitRevertModal, setPartyExitReverModal] = useState(false);
  const [revertData, setRevertData] = useState({
    user: "",
    partyId: 0,
  });
  const [fetchExMember, setFetchExMember] = useState(false);
  const setExMemberList = useSetRecoilState(exMemberListState);

  const isUplus = subsId === 900001;

  const { response } = useApi({
    method: "get",
    url:
      auth?.partyInfo && fetchExMember
        ? isUplus
          ? `uplus/${partyId}/users/1?page=0&size=5`
          : `party/${partyId}/users/1?page=0&size=5`
        : undefined,
  });

  useEffect(() => {
    if (response?.status === 200) {
      setExMemberList(response?.data?.items);
      setFetchExMember(false);
      fetchingEvent(); // 파티 정보, 파티 현재 인원 정보 fetch
    }
  }, [response]);

  return (
    <>
      <LineBtn
        btnText={
          d?.grade === 0 || d?.grade === 2
            ? "해산"
            : d?.mstate === 1
            ? "탈퇴 취소"
            : "탈퇴"
        }
        btnColor="red"
        btnClickEvent={() => {
          if (checkEvent) {
            checkEvent();
          } else {
            setPartyData({
              uid: d?.uid,
              name: d?.name,
              nickname: d?.nickname,
              partyId: partyId!,
              grade: d?.grade,
              subsId,
              membs: data?.members ?? 0,
              startdate: data?.startdate,
            });

            if (d?.mstate !== 1) {
              setPartyExitModal(true);
            } else {
              setRevertData({
                user: `${d?.uid}_${d?.name}_${d?.nickname}`,
                partyId: Number(partyId),
              });

              setPartyExitReverModal(true);
            }
          }
        }}
        disabled={!auth?.partyCancel}
      />

      {/* 파티 해산/탈퇴 모달 */}
      {partyExitModal && (
        <PartyExitModal
          partyData={partyData}
          closeEvent={() => setPartyExitModal(false)}
          confirmEvent={() => {
            setFetchExMember(true);
          }}
          ssetValue={data?.sset_value}
        />
      )}

      {/* 파티 탈퇴 취소 모달 */}
      {partyExitRevertModal && (
        <PartyExitRevertModal
          closeEvent={() => setPartyExitReverModal(false)}
          confirmEvent={() => {
            setFetchExMember(true);
          }}
          revertData={revertData}
        />
      )}
    </>
  );
}
